import { createLayouts } from '@layouts' // This is your createLayouts function
import * as LayoutsComponents from '@layouts/components' // Assuming './components' contains Vue components
import { useLayouts } from '@layouts/composable/useLayouts' // The composable
import '@layouts/styles/index.scss'
import { layoutConfig } from '@themeConfig' // Your theme configuration

const layoutsPlugin = {
    install(app) {
        // 1. Initialize the layout configuration by calling createLayouts
        // This will set up the global/internal config for the @layouts library
        createLayouts(layoutConfig)

        // 2. Register global components from @layouts/components (if any)
        // The `export * from './components'` in your createLayouts file suggests this.
        // Assuming LayoutsComponents is an object where keys are component names
        // and values are the component definitions.
        for (const componentName in LayoutsComponents) {
            // Ensure it's a valid Vue component before registering
            if (typeof LayoutsComponents[componentName] === 'object' && LayoutsComponents[componentName] !== null) {
                app.component(componentName, LayoutsComponents[componentName])
            }
        }

        // 3. Provide the useLayouts composable or expose it globally if needed
        // Given you use Composition API (based on our saved info), providing is a good pattern.
        // If you need it globally via this.$layouts, you'd use app.config.globalProperties.$layouts
        app.provide('useLayouts', useLayouts) // Now you can inject('useLayouts') in components
    },
}

export default layoutsPlugin
